import { GENERAL_MODULE_NAME } from '../common/const';

export const MODULE_NAME = GENERAL_MODULE_NAME.concat('_taskList');
export const FETCH_LIST_JSON_URL = '/activity/taskListJson';
export const LIST_PAGE_TYPE_ID = 849;

export const CARD_PREFIX_SELECTOR = 'taskboard-card';

export enum TaskListFilterFields {
	ActivityPriorityIds = 'activityPriorityIds',
	AssignedUserIds = 'assignedUserIds',
	AssigneeTypeId = 'assigneeTypeId',
	DaysToDueDate = 'daysToDueDate',
	DepartmentIds = 'departmentIds',
	AgencyIds = 'agencyIds',
	DueDateId = 'dueDateId',
	EntityStateIds = 'entityStateIds',
	EntityTypeIds = 'entityTypeIds',
	IncludeArchived = 'includeArchived',
	OwnerUserIds = 'ownerUserIds',
	SavedFilter = 'savedFilter',
	Search = 'search',
	ShowTeamActivities = 'showTeamActivities',
	SubjectIds = 'subjectIds',
	AutomationIds = 'automationIds',
}

export enum TaskStatus {
	ToDo = 235,
	InProgress = 236,
	Done = 237,
}
